<template>
  <div class="modal-container clearfix">
    <div class="add-box clearfix">
      <vxe-table
          border
          show-overflow
          ref="xTable"
          class="table-style"
          max-height="480"
          :auto-resize="true"
          align="center"
          :data="formData"
          :edit-rules="tableRules"
          :edit-config="{trigger: 'click', mode: 'cell'}"
      >
        <vxe-table-column width="55" align="center" v-if="!isUpdate">
          <template v-slot:header>
            <Button class="add-btn" icon="md-add" @click="insertEvent"></Button>
          </template>
          <template v-slot="{ row,$rowIndex }">
            <Button class="del-btn" icon="md-remove" @click="removeEvent(row,$rowIndex)"></Button>
          </template>
        </vxe-table-column>
        <vxe-table-column field="no" title="序号" width="60"></vxe-table-column>
        <vxe-table-column field="carNum" title="车牌号" width="90">
          <template v-slot:header>
            <span style="color: red">*</span>车牌号
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.carNum" placeholder="必填" @blur="clearTableV"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carTypeText" title="车辆类型" width="220">
          <template v-slot="scope">
            <Cascader class="cascader" style="width: 200px" v-model="scope.row.carTypeText" :data="carTypeList"
                      trigger="hover"
                      transfer></Cascader>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carNumColor" title="车牌颜色" width="120">
          <template v-slot="scope">
            <vxe-select
                v-model="scope.row.carNumColor"
                placeholder="请选择"
                :options="car_Num_Color"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carLength" title="车长(mm)" width="90">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.carLength" placeholder="选填" @blur="clearTableV"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carWidth" title="车宽(mm)" width="90">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.carWidth" placeholder="选填" @blur="clearTableV"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carHeight" title="车高(mm)" width="90">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.carHeight" placeholder="选填" @blur="clearTableV"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column title="车辆能源类型" field="energyType" width="120">
          <template v-slot="scope">
            <vxe-select
                v-model="scope.row.energyType"
                placeholder="请选择"
                :options="energy_Type"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="archivesNum" title="车辆行驶证档案编号" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.archivesNum" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)" @blur="clearV"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="identCode" title="车辆识别代码" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.identCode" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)" @blur="clearV"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="issueAuthority" title="发证机关" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.issueAuthority" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="totalWeight" title="车辆总质量(吨)" width="120">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.totalWeight" placeholder="选填" @blur="clearTableV"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="deadweight" title="核定载质量(吨)" width="120">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.deadweight" placeholder="选填" @blur="clearTableV"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="curbWeight" title="整备质量(吨)" width="120">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.curbWeight" placeholder="选填" @blur="clearTableV"
                       type="number" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="regTime" title="注册日期" width="120">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.regTime" type="date" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="issueTime" title="发证日期" width="120">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.issueTime" type="date" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="checkPassTime" title="检验有效期至" width="120">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.checkPassTime" type="date" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="owner" title="车辆所有人" width="90">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.owner" placeholder="选填" @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="useNature" title="使用性质" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.useNature" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="transportCardNum" title="车辆道路运输证号" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.transportCardNum" maxlength="25" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)" @blur="clearV"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="businessNum" title="经营许可证号" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.businessNum" type="number" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)" @blur="clearV"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="transportPassTime" title="有效期至" width="120">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.transportPassTime" type="date" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
<!--        <vxe-table-column field="drivingCardFrontImage" title="行驶证（正面）" width="120">-->
<!--          <template v-slot="scope">-->
<!--            <upload-img :row="scope.row" :fileKey="'drivingCardFrontImage'"-->
<!--                        :initFile="scope.row.drivingCardFrontImage"></upload-img>-->
<!--          </template>-->
<!--        </vxe-table-column>-->
<!--        <vxe-table-column field="drivingCardSubpageImage" title="行驶证（副页）" width="120">-->
<!--          <template v-slot="scope">-->
<!--            <upload-img :row="scope.row" :fileKey="'drivingCardSubpageImage'"-->
<!--                        :initFile="scope.row.drivingCardSubpageImage"></upload-img>-->
<!--          </template>-->
<!--        </vxe-table-column>-->
<!--        <vxe-table-column field="transportCardFrontImage" title="道路运输证（正面）" width="150">-->
<!--          <template v-slot="scope">-->
<!--            <upload-img :row="scope.row" :fileKey="'transportCardFrontImage'"-->
<!--                        :initFile="scope.row.transportCardFrontImage"></upload-img>-->
<!--          </template>-->
<!--        </vxe-table-column>-->
<!--        <vxe-table-column field="transportCardSubpageImage" title="道路运输证（副页）" width="150">-->
<!--          <template v-slot="scope">-->
<!--            <upload-img :row="scope.row" :fileKey="'transportCardSubpageImage'"-->
<!--                        :initFile="scope.row.transportCardSubpageImage"></upload-img>-->
<!--          </template>-->
<!--        </vxe-table-column>-->
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button @click="cancel">取消</Button>
      <Button status="primary" v-if="isExport" @click="impotEvent">上传导入文件</Button>
      <Button status="primary" @click="commit">保 存</Button>
    </div>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" remember>
      <Message ref="messageModal" @close="closeMessage" @cover="cover" :conImport="true"></Message>
    </vxe-modal>
  </div>
</template>

<script>
  import $C from "@/consts/index";
  import $api from '@/apiProvider';
  import XLSX from 'xlsx';
  import Message from "@/components/common/Message";
  import {getExcelTime, showLoading, hideLoading} from '@/utils/util';
  import auth from "@/utils/auth";
  import UploadImg from "@/components/common/UploadImg";

  export default {
    components: {Message},
    data() {
      return {
        isUpdate: false,
        isExport: false,
        formData: [{
          id: '',
          no: 1,
          carNum: null,
          carTypeText: [],
          owner: null,
          deadweight: null,
          carNumColor: null,
          carHeight: null,
          carLength: null,
          carWidth: null,
          totalWeight: null,
          transportCardNum: null,
          archivesNum: null,
          drivingCardFrontImage: null,
          drivingCardSubpageImage: null,
          transportCardFrontImage: null,
          transportCardSubpageImage: null,
          energyType: null,
          identCode: null,
          issueAuthority: null,
          curbWeight: null,
          regTime: null,
          issueTime: null,
          checkPassTime: null,
          useNature: null,
          businessNum: null,
          transportPassTime: null
        }],
        uploadHeaders: {
          Authorization: auth.getAuth().token,
          token: auth.getAuth().token,
        },
        car_Num_Color: [], // 业务类型选择框
        energy_Type: [],
        tableRules: {
          carNum: [
            {required: true, message: "请输入车牌号"}
          ],
          // transportCardNum: [
          //   {max: 12, min: 12, message: "请输入正确的车辆道路运输证号"}
          // ],
          archivesNum: [
            {max: 12, min: 12, message: "请输入正确的车辆行驶证档案编号"}
          ],
          identCode: [
            {max: 17, min: 17, message: "请输入正确的车辆识别代码"}
          ],
          businessNum: [
            {max: 12, min: 12, message: "请输入正确的经营许可证号"}
          ],
        },
        messageVisible: false,
        message: '',
        carTypeList: [],
        dict: [],
        coverData: []
      }
    },
    created() {
      this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
    },
    mounted() {
      this.getDict();
      this.getCarColor(40300, 'car_Num_Color');
      this.getCarColor(40400, 'energy_Type');
    },
    methods: {
      clearV() {
        this.$refs.xTable.clearValidate();
      },
      async getDict() {
        let res = await $api.dict.get("searchDic");
        if (res.status === 1) {
          this.dict = res.data;
          this.carTypeList = this.getCarType([], 40200);
          console.log(this.carTypeList);
        } else {
          this.$XModal.message(res.message);
        }
      },
      async getCarColor(code, key) {
        let res = await $api.dict.get("searchDic", {
          parentcode: code
        });
        if (res.status === 1) {
          let arr = [];
          let data = res.data;
          data.map(i => {
            arr.push({
              label: i.dictText,
              value: i.dictCode,
            })
          })
          this[key] = arr;
        } else {
          this.$XModal.message(res.message);
        }
      },
      getCarType(arr, code) {
        let that = this;
        this.dict.map(i => {
          if (i.dictCodeP === code) {
            let obj = {
              label: i.dictText,
              value: i.dictCode,
              children: [],
            }
            that.dict.map(j => {
              if (j.dictCodeP === i.dictCode) {
                obj.children.push({
                  label: j.dictText,
                  value: j.dictCode,
                })
              }
            })
            arr.push(obj);
          }
        })
        return arr;
      },
      setExport(boolean) {
        this.isExport = boolean;
      },
      impotEvent() {
        let that = this;
        this.$refs.xTable.readFile({
          types: ['xls', 'xlsx']
        }).then(evnt => {
          showLoading();
          const tableData = [];
          const files = evnt.target.files;
          const fileReader = new FileReader();
          fileReader.onload = (ev) => {
            const data = ev.target.result;
            const workbook = XLSX.read(data, {type: 'binary'});
            const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
            // 解析数据
            let xlsxData = csvData.split('\n');
            //删除xlsx列名
            xlsxData.splice(0, 1);
            xlsxData.forEach((vRow) => {
              if (vRow) {
                const vCols = vRow.split(',');
                let carTypeText = vCols[2];
                let carNumColor = vCols[3];
                let energyType = vCols[7];
                let color = '';
                let energy = '';
                let arr = [];
                if (carTypeText && carTypeText !== '') {
                  that.dict.map(i => {
                    if (i.dictText === carTypeText && i.dictCodeP !== 40200) {
                      arr.push(i.dictCodeP);
                      arr.push(i.dictCode);
                    }
                  })
                }
                if (carNumColor && carNumColor !== '') {
                  that.dict.map(i => {
                    if (i.dictText === carNumColor) {
                      color = i.dictCode;
                    }
                  })
                }
                if (energyType && energyType !== '') {
                  that.dict.map(i => {
                    if (i.dictText === energyType) {
                      energy = i.dictCode;
                    }
                  })
                }
                const item = {
                  id: '',
                  no: vCols[0],
                  carNum: vCols[1].trim(),
                  carTypeText: arr,
                  carNumColor: color,
                  carLength: vCols[4],
                  carWidth: vCols[5],
                  carHeight: vCols[6],
                  energyType: energy,
                  archivesNum: vCols[8],
                  identCode: vCols[9],
                  issueAuthority: vCols[10],
                  deadweight: vCols[11],
                  totalWeight: vCols[12],
                  curbWeight: vCols[13],
                  regTime: getExcelTime(vCols[14]),
                  issueTime: getExcelTime(vCols[15]),
                  checkPassTime: getExcelTime(vCols[16]),
                  owner: vCols[17],
                  useNature: vCols[18],
                  transportCardNum: vCols[19],
                  businessNum: vCols[20],
                  transportPassTime: getExcelTime(vCols[21]),
                };
                tableData.push(item);
              }
            })
            this.formData = tableData;
          }
          fileReader.readAsBinaryString(files[0]);
          setTimeout(() => {
            hideLoading();
          }, 1000);
        })
      },
      changeFile(imgUrl, row, key) {
        row[key] = imgUrl;
      },
      async insertEvent() {
        let record = {
          id: '',
          no: this.$refs.xTable.data.length + 1,
          carNum: null,
          carTypeText: [],
          owner: null,
          deadweight: null,
          carNumColor: null,
          carHeight: null,
          carLength: null,
          carWidth: null,
          totalWeight: null,
          transportCardNum: null,
          archivesNum: null,
          drivingCardFrontImage: null,
          drivingCardSubpageImage: null,
          transportCardFrontImage: null,
          transportCardSubpageImage: null,
          energyType: null,
          identCode: null,
          issueAuthority: null,
          curbWeight: null,
          regTime: null,
          issueTime: null,
          checkPassTime: null,
          useNature: null,
          businessNum: null,
          transportPassTime: null
        };
        let {row: newRow} = await this.$refs.xTable.insertAt(record, -1);
        this.$refs.xTable.data.push(record);
        await this.$refs.xTable.setActiveCell(newRow, "carNum");
      },
      async validEvent() {
        let errMap = await this.$refs.xTable
          .validate()
          .catch((errMap) => errMap);
        return errMap ? false : true
      },
      removeEvent(row, i) {
        if (this.$refs.xTable.tableData.length > 1) {
          this.$XModal.confirm("您确定要删除该数据?").then((type) => {
            if (type === "confirm") {
              this.$refs.xTable.remove(row);
              this.$refs.xTable.data.splice(i, 1);
              if (this.isExport === false) {
                this.$refs.xTable.data.map((j, index) => {
                  j.no = index + 1;
                })
              }
            }
          });
        } else {
          this.$XModal.alert({
            message: "已经是最后一条了！",
            status: "warning",
          });
        }
      },
      closeMessage() {
        this.messageVisible = false;
      },
      clearTableV() {
        this.$refs.xTable.clearValidate();
      },
      async commit() {
        let sts = await this.validEvent()
        if (!sts) {
          this.$XModal.message({status: "error", message: "校验不通过！"});
          return
        }
        if (this.formData[0].id === '') {
          this.save()
        } else {
          this.update()
        }
      },
      async save() {
        showLoading();
        let arr = [];
        this.formData.map(i => {
          let obj = Object.assign({}, i);
          obj.carTypeText = obj.carTypeText.toString();
          obj.carNum = obj.carNum.trim();
          if (obj.regTime) {
            obj.regTime = this.$utils.timestamp(obj.regTime);
          }
          if (obj.issueTime) {
            obj.issueTime = this.$utils.timestamp(obj.issueTime);
          }
          if (obj.checkPassTime) {
            obj.checkPassTime = this.$utils.timestamp(obj.checkPassTime);
          }
          if (obj.transportPassTime) {
            obj.transportPassTime = this.$utils.timestamp(obj.transportPassTime);
          }
          arr.push(obj);
        })
        let res = await $api.carShip.request('createCar', arr);
        hideLoading();
        if (res.status === 1) {
          this.$Message.success('提交成功');
          this.close();
          this.$emit('afterSave', 'afterSave');
        } else {
          let data = res.data;
          let message = '';
          if (data.length > 0) {
            data.map(i => {
              message = message + '序号' + (this.formData[i.failArrayIndex].no) + '，' + i.failMsg + '\n';
            })
            let errorData = [];
            let coverData = [];
            res.data.forEach(failItem => {
              errorData.push(Object.assign({}, this.formData[failItem.failArrayIndex]));
              coverData.push(failItem.vo);
            })
            this.formData = errorData;
            this.coverData = coverData;
          }
          if (message === '') {
            this.$XModal.alert({
              message: "接口异常",
              status: "error",
            });
          } else {
            this.$refs.messageModal.setMessage(message);
            this.messageVisible = true;
          }
        }
      },
      cover() {
        this.$XModal.confirm('确认继续导入，将更新原有数据！').then(type => {
          if (type === 'confirm') {
            this.coverImport();
          }
        })
      },
      async coverImport() {
        showLoading();
        let res = await $api.carShip.request('coverCar', this.coverData);
        hideLoading();
        if (res.status === 1) {
          this.$Message.success('更新成功');
          this.messageVisible = false;
          this.close();
          this.$emit('afterSave', 'afterSave');
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      cancel() {
        this.close();
        this.$emit('afterSave', 'close')
      },
      close() {
        this.isUpdate = false;
        this.formData = [{
          id: '',
          no: 1,
          carNum: null,
          carTypeText: [],
          owner: null,
          deadweight: null,
          carNumColor: null,
          carHeight: null,
          carLength: null,
          carWidth: null,
          totalWeight: null,
          transportCardNum: null,
          archivesNum: null,
          drivingCardFrontImage: null,
          drivingCardSubpageImage: null,
          transportCardFrontImage: null,
          transportCardSubpageImage: null,
          energyType: null,
          identCode: null,
          issueAuthority: null,
          curbWeight: null,
          regTime: null,
          issueTime: null,
          checkPassTime: null,
          useNature: null,
          businessNum: null,
          transportPassTime: null
        }];
        this.coverData = [];
      }
    }
  }
</script>

<style scoped>
  .upload-box {
    height: 56px;
    width: 56px;
    line-height: 56px;
    border: 1px dashed #dcdee2;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    display: inline-block;
  }

  .upload-list {
    display: inline-block;
    width: 56px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    vertical-align: middle;
  }

  .cascader >>> .ivu-cascader-arrow {
    position: absolute;
    top: 50% !important;
    right: 8px !important;
    line-height: 1;
    transform: translateY(-50%);
    font-size: 14px;
    color: #808695;
    transition: all .2s ease-in-out;
  }

  .select >>> .ivu-select-arrow {
    position: absolute;
    top: 50% !important;
    right: 8px !important;
    line-height: 1;
    transform: translateY(-50%);
    font-size: 14px;
    color: #808695;
    transition: all .2s ease-in-out;
  }
</style>